export * from './TenantPreferenceForm'
export { SimplifiedTenantPreferenceForm } from './components'
